<template>
  <h2 class="pb-2 border-bottom">PRP & Microneedling</h2>
  <p>Regeneración Natural para la Piel, el Cabello y el Bienestar</p>
  <p>Las terapias con PRP (Plasma Rico en Plaquetas) utilizan los propios factores de crecimiento del cuerpo para estimular la curación natural y la regeneración. Bajo supervisión médica, el PRP puede apoyar el rejuvenecimiento de la piel, la restauración capilar, el alivio del dolor y el bienestar general — con mínimo tiempo de recuperación.</p>
  <h3>Aplicaciones principales</h3>
  <ul>
    <li>PRP para rejuvenecimiento de la piel — estimula colágeno, mejora textura y aporta luminosidad natural.</li>
    <li>PRP para restauración capilar — fortalece folículos, reduce la caída y estimula nuevo crecimiento.</li>
    <li>PRP para articulaciones & dolor — ayuda en artritis, tendinitis y recuperación de lesiones.</li>
    <li>PRP para bienestar — terapias que apoyan vitalidad y confianza (O-Shot/P-Shot pueden detallarse en la web, pero no en anuncios).</li>
    <li>PRP para cicatrices — reduce pigmentación y suaviza marcas de acné o lesiones.</li>
  </ul>
  <h3>Cómo funciona</h3>
  <ol>
    <li>Extracción de una pequeña muestra de sangre.</li>
    <li>Separación del PRP en centrífuga.</li>
    <li>Aplicación mediante microneedling o inyección.</li>
    <li>Recuperación rápida — enrojecimiento/inflamación leves por 24–48h.</li>
  </ol>
  <p>“El PRP combina ciencia y curación natural para restaurar equilibrio y confianza de manera segura y eficaz.”</p>
</template>

<script>
export default {
  name: 'PRPMicroneedlingFacialContentEs'
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
